import { RouterItem } from '@/utils/interfaces';
import AdminMainLayout from '@/layouts/admin/MainLayout.vue';

/** 用户个人功能 */
const routesMap: RouterItem[] = [
  {
    path: '/manage',
    // redirect: '/user/changePassword',
    component: AdminMainLayout,
    // meta: { title: '用户中心', icon: 'user' },
    children: [
      {
        path: '',
        name: 'manage',
        component: () => import(/* webpackChunkName: "common" */ '@/views/Home.vue'),
        meta: { title: '首页', icon: 'home' },
      },
    ],
  },
];

export default routesMap;
